import firebase from "../../firebase";

export default function({ officeId, licenseId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "billingAdmin",
        funcName: "removeLicenseFromOffice",
        data: {
            officeId,
            licenseId
        }
    });
}
